import * as THREE from 'three'
require('three-orbitcontrols');

import printModel from '../../../3dapps/mixins/printModel';
import { initThree, scene, camera, renderer, currentMesh, updateModel } from './initThree'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import loading from '@/components/loading';
import { getThreeFonts } from '../../../3dapps/js/fontManage.js';


const contentList = [
"子曰，学而时习之，不亦说乎？",
"衣带渐宽终不悔，为伊消得人憔悴。",
"埋骨何须桑梓地，人生何处不青山。",
"你站在桥上看风景，看风景的人在楼上看你。",
"学而不思则罔，思而不学则殆。",
"读一本好书，就如同和一个高尚的人在交谈。"
];

export default {
name: "bamboo",
mixins: [printModel],
components: {
Group,
XDialog,
Actionsheet,
Grid, GridItem, XNumber, XInput, Popup, Radio, Flexbox, FlexboxItem,
Toast, XSwitch, XTextarea, XButton, loading
},

data() {
return {
quotationName: "3D竹简",
landscape: true,//竖屏状态要一直为true
addCartIndex: -1,
orderIndex: -1,
isreliefBtnIndex: -1,//顶部按钮默认
fontsItemIndex: 0,//初始值-字体
showText: false,
showFonts: false,
showSize: false,
showPrint: false,
productType: "3D竹筒",
showLoading: false,
fontsData: [],
showbtnSure: true,
bambooData: {
w: 20,
h: 200,
t: 2,
p1: 2, // 左右边距
p2: 10, // 上下边距
r: 1, // 孔，半径
text: contentList[Math.floor(Math.random() * contentList.length)],
font: ""
},
sizeList: [{
title: "宽度",
num: 20,
placeholder: "宽度不能超过200MM",
}, {
title: "高度",
num: 200,
placeholder: "高度不能超过200MM",
}, {
title: "厚度",
num: 2,
placeholder: "厚度不能超过9MM",
}],
btnsList: [//按钮列表
{
isClick: false,
icon: require("../../../3dapps/imgs/编辑.png"),
iconClick: require("../../../3dapps/imgs/编辑-选中.png"),
title: "文字",
},
{
isClick: false,
icon: require("../../../3dapps/imgs/字体.png"),
iconClick: require("../../../3dapps/imgs/字体-选中.png"),
title: "字体",
},
{
isClick: false,
icon: require("../../../3dapps/imgs/尺寸.png"),
iconClick: require("../../../3dapps/imgs/尺寸-选中.png"),
title: "尺寸",
},
],
}
},
mounted() {
const scope = this;
scope.showLoading = true;
scope.loadlistBrand();

var mo = function (e) {
e.preventDefault();
}


scope.$nextTick(function () {
scope.$refs.bamboo.style.paddingTop = '0px';
scope.$refs.bamboo.style.overflow = 'hidden';
scope.$refs.canvas.addEventListener("touchmove", mo, false);
});

initThree(scope.$refs.canvas);


const contentDOM = scope.$refs.bamboo;


const resize1 = function (e) {
if (!scope.$refs.canvas) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight;



scope.$refs.canvas.width = w; 
scope.$refs.canvas.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}
scope.init3d(contentDOM, camera, renderer, resize1);
setTimeout(function () {
scope.showLoading = false;
}, 50);
},

methods: {

loadData() {
const scope = this;
if (window.localStorage) {
let dataStr = localStorage.getItem("bambooData");
localStorage.removeItem("bambooData"); 
if (dataStr) {
let data = JSON.parse(dataStr);
scope.bambooData.w = data.w;
scope.bambooData.h = data.h;
scope.bambooData.t = data.t;
scope.bambooData.font = data.font;
scope.bambooData.text = data.text;
scope.fontsItemIndex = data.fontsItemIndex;


scope.showLoading = true;

setTimeout(function () {
scope.showLoading = false;
}, 50);
}
}
},


saveData() {
if (window.localStorage) {
let data = {};
data.w = this.bambooData.w;
data.h = this.bambooData.h;
data.t = this.bambooData.t;
data.font = this.bambooData.font;
data.text = this.bambooData.text;
data.fontsItemIndex = this.fontsItemIndex;

localStorage.setItem("bambooData", JSON.stringify(data));
}
},


loadlistBrand() {
const scope = this;


getThreeFonts(this).then(fontsDisp => {
scope.fontsData = fontsDisp;
scope.bambooData.font = scope.fontsData[0].fontName;
scope.refresh3d();
});
},


touchstart() {
this.isBtnList0();
this.showFonts = false;
this.btnsList[1].isClick = false;
this.btnsList[2].isClick = false;
this.updatedData();
},

isBtnList0() {
this.btnsList[0].isClick = false;
this.isreliefBtnIndex = -1;
this.showSize = false;
this.showText = false;
this.showFonts = false;
},

isBtnList1() {
this.btnsList[1].isClick = false;
this.isreliefBtnIndex = -1;
this.showSize = false;
this.showFonts = false;
this.showText = false;
},

isBtnList2() {
this.btnsList[2].isClick = false;
this.isreliefBtnIndex = -1;
this.showSize = false;
this.showText = false;
this.showFonts = false;
},


handler(index) {
if (index === 0) {//文字
this.isreliefBtnIndex = index;
this.showText = true;

this.showSize = false;
this.showFonts = false;
this.btnsList[0].isClick = true;
this.btnsList[2].isClick = false;
this.btnsList[1].isClick = false;
this.updatedData();




return;
} else if (index === 1) {//字体
this.isreliefBtnIndex = index;
this.showFonts = !this.showFonts;
this.showSize = false;
this.showText = false;
this.btnsList[1].isClick = true;
this.btnsList[0].isClick = false;
this.btnsList[2].isClick = false;

if (!this.showFonts) {
this.isBtnList1();
}
return;
} else if (index === 2) {//尺寸
this.isreliefBtnIndex = index;
this.showSize = true;

this.showText = false;
this.showFonts = false;
this.btnsList[2].isClick = true;
this.btnsList[0].isClick = false;
this.btnsList[1].isClick = false;
this.updatedData();




return;
}
},


onfontsItemClick(index) {
const scope = this;
scope.showFonts = false;
scope.fontsItemIndex = index;
scope.showLoading = true;
scope.bambooData.font = scope.fontsData[scope.fontsItemIndex].fontName;
console.log("font:", scope.bambooData);

setTimeout(function () {
if (currentMesh) {
scene.remove(currentMesh);

}
scope.isBtnList1();
scope.showLoading = false;
scope.refresh3d();
scope.isNoData();
}, 50);
},

refresh3d() {
updateModel(this, this.bambooData);
},


isClosebambooText() {
if (this.bambooData.text == "") {
this.$vux.toast.show({
text: '文本输入不能为空！',
type: "cancel",
time: 2000,
position: "middle",
});
this.showText = true;
return;
}
this.isBtnList0();
},


onChangeText() {
if (this.bambooData.text == "") {
this.$vux.toast.show({
text: '请输入文字！',
type: "warn",
time: 2000,
position: "middle",
})
return;
}
this.isBtnList0();
this.showText = false;
this.refresh3d();
},


updatedData() {
if (this.bambooData.h == "" && this.bambooData.t == "" || this.bambooData.h == "" || this.bambooData.t == "") {
this.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
} else if (this.bambooData.text == "") {
this.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.showText = true;
this.showSize = false;
this.showLoading = false;
} else if (this.bambooData.h < 50) {
this.$vux.toast.show({
text: '高度不能小于50毫米',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
} else if (this.bambooData.h > 500) {
this.$vux.toast.show({
text: '高度不能大于500毫米',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
} else if (this.bambooData.t < 2) {
this.$vux.toast.show({
text: '厚度不能小于2毫米',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
} else if (this.bambooData.t > 10) {
this.$vux.toast.show({
text: '厚度不能大于10毫米',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
}
setTimeout(() => {
this.showLoading = false;
this.refresh3d();
}, 50);
},

isNoData() {
const scope = this;
if (scope.bambooData.h == "" && scope.bambooData.t == "" || scope.bambooData.h == "" || scope.bambooData.t == "") {
scope.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
scope.bambooData.h = 200;
scope.bambooData.t = 2;
scope.showSize = true;
scope.showLoading = false;
} else if (scope.bambooData.text == "") {
scope.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
scope.bambooData.text = "齐思印";
scope.showText = true;
scope.showSize = false;
scope.showLoading = false;
}
},


cancelPop() {
this.isBtnList2();
this.updatedData();
},


isSure() {
this.isBtnList2();
this.showLoading = true;
this.updatedData();
},


print() {
this.showFonts = false;
this.showSize = false;
this.showText = false;
this.showLoading = true;
this.isNoData();



if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showlowpriceHeight = true;

}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showlowpriceHeight = false;

}

if (currentMesh) {
this.saveData();
this.$nextTick(function () {
this.showPrint = true;
this.makeModelForPrint();
const scope = this;
this.getPrice().then(() => {
scope.showLoading = false;
});
});
}else {
this.$vux.toast.show({
text: '3D竹简不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.refresh3d();
this.showLoading = false;
}















},

makeStlBlob() {
let exporter = new THREE.STLExporter();
let group = new THREE.Group();
group.add(currentMesh.clone());

let result = exporter.parse(group, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });
return blob;
},


getModelToPrint() {
let group = currentMesh;
return group;
},
},
watch: {
'bambooData.text': function () {
if (this.bambooData.text == "") {
this.showbtnSure = false;
return;
} else {
this.showbtnSure = true;
}
}
},
}


// WEBPACK FOOTER //
// ./src/views/bamboo3d/script/index.js